import {
    OpType,
    SubscriptionMessage
} from '@aws-amplify/datastore';

import { ContextAwareIdentifier } from '../design/document/ContextAwareIdentifier';
import { DataStore } from 'aws-amplify';
import { Dimension } from '../../models';
import { ModelType } from '../design/document/ModelType';
import { StateContext } from '../design/document/state/StateContext';
import { dimensionByDimensionIdentifierSelectorFamily } from '../design/document/state/DocumentState';
import { useRecoilCallback } from 'recoil';

let subscription: ZenObservable.Subscription | undefined;

export const useDimensionSubscription = () => {
    const handleDimensionUpdate = useRecoilCallback(({ set, reset }) => async (message: SubscriptionMessage<Dimension>, context: StateContext) => {
        const dimensionIdentifier = new ContextAwareIdentifier(message.element.id, context, ModelType.DIMENSION);

        if (message.opType === OpType.DELETE) {
            reset(dimensionByDimensionIdentifierSelectorFamily(dimensionIdentifier));
            return;
        }

        const dimension = message.element;
        set(dimensionByDimensionIdentifierSelectorFamily(dimensionIdentifier), dimension);
    });

    const subscribe = async (propertyId: string) => {
        subscription = DataStore.observe(Dimension, (dimension) =>
            dimension.propertyId("eq", propertyId)
        ).subscribe({
            next: (message: SubscriptionMessage<Dimension>) => {
                handleDimensionUpdate(message, StateContext.INSPECTION);
            },
            error: (error) => console.warn(error)
        });
    };

    const unsubscribe = () => {
        subscription?.unsubscribe();
    };

    return { subscribe, unsubscribe };
};